/**
 * Core logs date helpers. Default list has no date window; the API returns
 * newest rows first. Dates are only sent when the user picks From/To.
 */
export function formatCoreLogSearchDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}%20${hours}:${minutes}`;
}

/** No search params — backend returns latest logs first, with no date limit. */
export function buildCoreLogsDefaultFilterUrl() {
    return '';
}
